import React from 'react'
import styled from 'styled-components'

import STYLE_CONSTANTS from '~/style/constants'

import Center from '../basic/Center'

const Container = styled.div`
  padding: 1.5rem;
  min-height: 200px;
`

const Text = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 1.2rem;
  color: ${STYLE_CONSTANTS.colors.text.subtleGray};
`

const Loading = ({ message }) => {
  return (
    <Container>
      <Center>
        <Text>{message || 'Loading'}</Text>
      </Center>
    </Container>
  )
}

export default Loading
